import {makeStyles} from '@material-ui/core';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import PortalFooter from './PortalFooter';

const useStyles = makeStyles(theme => ({
  wrapper: {
    [theme.breakpoints.between('sm', 'lg')]: {
      position: 'sticky',
      zIndex: 1000,
    },
  },
}));

export const xsBreakpoint = 680;

const PortalFooterWrapper = () => {
  const {BR_Footer} = useSelector((state: ReducerState) => state.featureFlag);
  const classes = useStyles();

  return (
    <>
      {BR_Footer && (
        <div className={classes.wrapper}>
          <PortalFooter />
        </div>
      )}
    </>
  );
};

export default PortalFooterWrapper;
